import Ando from './Ando'

export default Ando
